import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHEstablecimientoIns = async (credentials, data) => {
    const body = {
        service: "RNHEstablecimientoIns",
        params: {
            rnhTipoComponenteCod: data?.type || '',
            rnhEstablecimientoCod: data?.cod,
            rnhEstablecimientoNombre: data?.name,
            rnhNivelId: data?.nivelId,
            rnhAreaId: data?.areaId,
            rnhEstablecimientoCabecera: data?.cabecera,
            rnhEstablecimientoCalle: data?.calle,
            rnhEstablecimientoNumero: data?.numero,
            rnhEstablecimientoPiso: data?.piso,
            rnhEstablecimientoCPA: data?.cpa,
            rnhEstablecimientoUnidad: data?.unidad,
            localidadId: data?.localidadId,
            rnhEstablecimientoLatitud: data?.lat,
            rnhEstablecimientoLongitud: data?.lng,
            // Los dos permisos del establecimiento. UNA SOLA TABLA para los cinco tipos,
            // asi que un solo par de params para todos.
            //
            // EN HOSPITAL Y URESA LOS DECIDE EL BACK, que valida contra el tipo: lo que
            // mandemos para esos dos no manda. En CAPS, puestos y postas vale lo que
            // viaja desde el formulario.
            rnhEstablecimientoAdmiteRotativos: data?.admiteRotativos || null,
            rnhEstablecimientoAdmiteGuardias: data?.admiteGuardias || null,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
